import { gql } from '@apollo/client'

/** Only whether reading past ad results is switched on for the licence (the navigation entry). */
export const GET_AD_HISTORY_ENABLED = gql`
    query AdHistoryEnabled($campaignId: String!) {
        adHistoryStatus(campaignId: $campaignId) {
            enabled
        }
    }
`

/** How far the daily read of the licence's ad results has got, per ad account. */
export const GET_AD_HISTORY_STATUS = gql`
    query AdHistoryStatus($campaignId: String!) {
        adHistoryStatus(campaignId: $campaignId) {
            enabled
            stale
            lastSuccessUntil
            groups {
                adAccount
                status
                stallReason
                lastSuccessUntil
                nextAttemptAt
                daysStored
                firstDay
            }
            refreshPending
            nextRefreshAllowedAt
        }
    }
`

/** The winning ad copy with what generation does with each, and the copy that does not lead yet. */
export const GET_AD_HISTORY_WINNERS = gql`
    query AdHistoryWinners($campaignId: String!, $purpose: GenerationBasisPurpose) {
        adHistoryWinners(campaignId: $campaignId, purpose: $purpose) {
            enabled
            mode
            automatedAllowed
            state
            reason
            asOf
            winners {
                key
                state
                dropReason
                headline
                primaryText
                format
                resultKind
                currency
                results
                spend
                costPerResult
                deliveryDays
                pBest
                adSets
                enteredAt
            }
            others {
                headline
                primaryText
                format
                resultKind
                currency
                results
                spend
                costPerResult
                deliveryDays
                reasons
            }
        }
    }
`

/** Asks for the licence's results to be read at the next hourly pass (at most once every 6 hours). */
export const REFRESH_AD_HISTORY = gql`
    mutation RefreshAdHistory($campaignId: String!) {
        refreshAdHistory(campaignId: $campaignId) {
            requested
            reason
            nextAllowedAt
        }
    }
`
